import { useLocale } from '../i18n/LocaleProvider'
import CorporatePageLayout from '../components/CorporatePageLayout'
import { usePageTitle } from '../hooks/usePageTitle'
import './PublicInfoPage.css'

const COLUMNS = [
  {
    language: 'ja',
    overviewTitle: '現在の稼働状況',
    status: '現在、把握している障害はありません。',
    detail: '確認したサービス障害は、このページでお知らせします。',
    servicesTitle: 'サービス別ステータス',
    incidentTitle: '障害情報',
    noIncidents: '現在、掲載中の障害情報はありません。',
    services: [
      { name: 'コーポレートサイト', state: '障害情報なし' },
      { name: 'ブログ・ニュースルーム', state: '障害情報なし' },
      { name: 'お問い合わせフォーム', state: '障害情報なし' },
    ],
  },
  {
    language: 'en',
    overviewTitle: 'Current Availability',
    status: 'There are no known incidents at this time.',
    detail: 'Confirmed service disruptions will be posted on this page.',
    servicesTitle: 'Service Status',
    incidentTitle: 'Incident Updates',
    noIncidents: 'There are no incident updates currently posted.',
    services: [
      { name: 'Corporate Website', state: 'No known issues' },
      { name: 'Blog & Newsroom', state: 'No known issues' },
      { name: 'Inquiry Form', state: 'No known issues' },
    ],
  },
] as const

export default function StatusPage() {
  const { locale, t } = useLocale()
  usePageTitle('Service Status')

  return (
    <CorporatePageLayout
      title={t("Service Status")}
      japaneseSubtitle={(
        <>
          バイバイトが提供するサービスの稼働状況と<br />
          障害情報をご確認いただけます。
        </>
      )}
      englishSubtitle={(
        <>
          View current availability and incident updates<br />
          for Bybeit services.
        </>
      )}
    >
      <main className="ip-main container">
        <div className="ip-language-grid">
          {COLUMNS.filter(column => column.language === locale).map((column) => (
            <div
              className={`ip-language-column ip-language-column--${column.language}`}
              key={column.language}
              lang={column.language}
            >
              <section className="ip-section">
                <h2 className="ip-section-title">{column.overviewTitle}</h2>
                <div className="ip-message">
                  <div className="ip-status-heading">
                    <span className="ip-status-dot" aria-hidden="true" />
                    <p className="ip-message-title">{column.status}</p>
                  </div>
                  <p className="ip-message-copy">{column.detail}</p>
                </div>
              </section>

              <section className="ip-section">
                <h2 className="ip-section-title">{column.servicesTitle}</h2>
                <ul className="ip-service-list">
                  {column.services.map((service) => (
                    <li className="ip-service-item" key={service.name}>
                      <span className="ip-service-name">{service.name}</span>
                      <span className="ip-service-state">{service.state}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section className="ip-section">
                <h2 className="ip-section-title">{column.incidentTitle}</h2>
                <p className="ip-message-copy">{column.noIncidents}</p>
              </section>
            </div>
          ))}
        </div>
      </main>
    </CorporatePageLayout>
  )
}
